import React, { Component } from 'react';
import { MyButton } from '../UI/MyButton/MyButton';
import { RiShoppingCart2Fill } from "react-icons/ri";

export class Item extends Component {
    render() {
        return (
            <div className='item'>
                <img src={'./img/' + this.props.item.img} onClick={() => this.props.onShowItem(this.props.item)} />
                <h2>{this.props.item.title}</h2>
                <p>{this.props.item.desc}</p>
                <b>{this.props.item.price}$</b>
                <MyButton className='add_to_cart' onClick={() => this.props.onAdd(this.props.item)}><RiShoppingCart2Fill />КУПИТЬ</MyButton>
            </div>
        )
    }
}

export default Item;